import React, { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import TextField from 'cityads-v3/components/TextField/TextField';

import classes from './OfferGetLink.scss';

export default function GetLinkTabPanelOffer({ code, onSelectCode, onCopyCode, isServerRedirect, onChangeRedirect, isShortLink, onToggleShortLink, linkLabel }) {
  const { t } = useTranslation(['Offers']);

  const handleRedirectChange = useCallback(evt => {
    onChangeRedirect(evt.target.checked);
  }, [onChangeRedirect]);

  const inputRef = useRef(null);

  const copyCode = useCallback(evt => {
    inputRef.current.select();
    document.execCommand('copy');
  }, []);

  return (
    <div className={classes.linkTabPanel}>
      <div className={classes.linkControl}>
        <FormControlLabel
          control={<Switch name="serverRedirect" color="primary" checked={isServerRedirect} onChange={handleRedirectChange} />}
          label={t('exports.useServerRedirect')}
        />
      </div>

      <TextField
        label           = {linkLabel || t('exports.fullLink')}
        multiline       = {true}
        minRows         = {2}
        fullWidth       = {true}
        value           = {code || ''}
        inputRef        = {inputRef}
        InputLabelProps = {{ shrink: true }}
        inputProps      = {{
          "data-getlink": "fullLink"
        }}
        onFocus         = {onSelectCode}
        onCopy          = {onCopyCode}
      />
      <div className={classes.copyCodeButtons}>
        <Button
          variant = "contained"
          onClick = {copyCode}
          color   = "primary"
        >
          {t('exports.copy')}
        </Button>
        <Button
          variant = "text"
          onClick = {onToggleShortLink}
        >
          {isShortLink ? t('exports.getFullLink') : t('exports.getShortLink')}
        </Button>
      </div>
    </div>
  );
}
